module.exports = __webpack_public_path__ + "img/option-card-center-active-modal-icon.7b7d5abb.svg";